(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/content-editable-defaultable
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Non-blank contenteditable elements with default to initial value.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("content-editable-defaultable") === undefined) {
    class ContentEditableDefaultable extends HTMLElement {
        constructor(){
            super();
        }
        connectedCallback() {
            this.editableContent = this.querySelector('[contenteditable="true"]');
            this.defaultContent = this.editableContent?.innerText;
            this.editableContent?.addEventListener("focusin", this.focusInEvent.bind(this), false);
            this.editableContent?.addEventListener("focusout", this.focusOutEvent.bind(this), false);
        }
        focusInEvent() {
            if (this.editableContent.innerText !== this.defaultContent) return;
            this.editableContent.innerText = "";
        }
        focusOutEvent() {
            this.editableContent.innerText = this.editableContent.innerText.trim();
            if (this.editableContent.innerText !== "") return;
            this.editableContent.innerText = this.defaultContent;
        }
    }
    customElements.define("content-editable-defaultable", ContentEditableDefaultable);
}



})();
